export default "__VITE_ASSET__DIPuyp5N__"